module.exports = __webpack_public_path__ + "static/media/assessment.9fd990c9.png";